import { TrlFilterQuestionDto, TrlFilterQuestionsSelectDto } from '@@types/api.types';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetTrlFilterQuestions = () => {
  const { apiGet } = useApi();

  return useQuery<TrlFilterQuestionDto[], ApiErrorWrapper>({
    queryFn: async () => {
      const result = await apiGet<TrlFilterQuestionsSelectDto>({
        path: '/v1/data/trl-filter-questions',
      });
      return result.questions;
    },
    queryKey: queryKeys.trlFilterQuestions.getTrlFilterQuestions,
  });
};
